export enum SocietyTypeId {
  SA = 1,
  SRL = 2,
  SAS = 3,
  SH = 4,
  CAPITULO_IV = 5,
  ASOCIACION_FUNDACION = 6,
  COOPERATIVA = 7,
  SCS = 8,
  SCA = 9,
}

export enum DocumentTypeId {
  ESTATUTO_SOCIAL = 1,
  INSCRIPCION_ESTATUTO = 2,
  ACTA_AUTORIDADES = 3,
  CERTIFICACION_AUTORIDADES = 4,
  MODIFICACIONES_ESTATUTO = 5,
  PODER_GENERAL = 6,
  CONSTANCIA_AFIP = 7,
  CONTRATO_CAPITULO_IV = 8,
  PERSONERIA_JURIDICA = 9,
  CONSTANCIA_INAES = 10,
  OTRO = 11,
}

export type SocietyTypeIdType = SocietyTypeId;
export type DocumentTypeIdType = DocumentTypeId;
